import { render, staticRenderFns } from "./ywyeInstructions.vue?vue&type=template&id=581ea44e&scoped=true&"
import script from "./ywyeInstructions.vue?vue&type=script&lang=js&"
export * from "./ywyeInstructions.vue?vue&type=script&lang=js&"
import style0 from "./ywyeInstructions.vue?vue&type=style&index=0&id=581ea44e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581ea44e",
  null
  
)

export default component.exports